import styles from "./Form.module.scss";
import { useState } from "react";
import sendContactForm from "../../../lib/sendAboutForm";
import useContactForm from "../../../hooks/useContactForm";
import { SecoundaryButton } from '../Buttons/Buttons'

export default function Form() {
    const { values, handleChange } = useContactForm();
    const [responseMessage, setResponseMessage] = useState(
        { isSuccessful: false, message: '' });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setTimeout(() => {
            setResponseMessage({ isSuccessful: true }),
                values.fullname = "",
                values.email = "",
                values.phoneno = "",
                values.message = ""
        }, 3000)
        try {
            const req = await sendContactForm(values.fullname, values.email, values.phoneno, values.message);
            if (req.status === 250) {
                setResponseMessage({ isSuccessful: true, message: 'Thank you for your message.' });
                alert("Thank you for your message.")
            }

        } catch (e) {
            console.log(e);
            setResponseMessage({
                isSuccessful: false,
                message: 'Oops something went wrong. Please try again.',
            });
        }
    };

    return (
        <>
            <section className={`${styles.form} common_padding`}>
                <div className="row">
                    <div className="col-md-8 offset-md-2 col-sm-12 contact_form">
                        <form className="row" onSubmit={handleSubmit}>
                            <div className={`${styles.form_group} col-md-6 col-sm-12`}>
                                <input
                                    id="fullname"
                                    type="text"
                                    name="fullname"
                                    onChange={handleChange}
                                    value={values.fullname}
                                    className="form-control"
                                    placeholder="Full Name"
                                    required
                                />
                            </div>
                            <div className={`${styles.form_group} col-md-6 col-sm-12`}>
                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    onChange={handleChange}
                                    value={values.email}
                                    className="form-control"
                                    placeholder="Your Email"
                                    required
                                />
                            </div>
                            <div className={`${styles.form_group} col-md-12`}>
                                <input
                                    id="phoneno"
                                    required
                                    name="phoneno"
                                    type="number"
                                    onChange={handleChange}
                                    value={values.phoneno}
                                    className="form-control"
                                    placeholder="Phone Number"
                                />
                            </div>
                            <div className={`${styles.form_group} col-md-12`}>
                                <textarea
                                    id="message"
                                    name="message"
                                    onChange={handleChange}
                                    value={values.message}
                                    className="form-control"
                                    placeholder="Message"
                                    required
                                ></textarea>
                            </div>
                            {/* <button type="submit" className="secoundary_btn">SEND REQUEST</button> */}

                            <div className="col-md-12 text-center">
                                <SecoundaryButton type="submit" buttonText={'SEND REQUEST'} />
                            </div>

                            {responseMessage.isSuccessful === true ? (
                                <p className="success text-center">We appreciate you contacting us. One of our customer happiness members will be getting back to you shortly.</p>
                            ) : ('')}
                        </form>
                    </div>
                </div>
            </section>
        </>
    )
}
